import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const userSegmentationRoute: InvariantJiraRoute = {
	name: 'user-segmentation',
	path: '/jira/get-started',
	exact: true,
};
